import Reflux from 'reflux';
import SIM from '../../sim/core';
import fullScreenActions from '../../actions/fullscreen';
import embeddedCheckout from '../../utils/embeddedCheckout';

export default class FullScreenStore extends Reflux.Store {
  static id = 'fullscreen';

  constructor () {
    super();

    this.state = {
      modules:      {},
      activeModule: false,
      scrollTop: 0
    };

    this.listenTo(fullScreenActions.fix, 'fix');
    this.listenTo(fullScreenActions.unfix, 'unfix');
    this.listenTo(fullScreenActions.toggle, 'toggle');
    this.listenTo(fullScreenActions.register, 'register');
    this.listenTo(fullScreenActions.deregister, 'deregister');
  }

  fix (name) {
    if (embeddedCheckout.isEnabled()) {
      embeddedCheckout.expandFullScreen();
    }

    this.setState({
      activeModule: name,
      scrollTop: document.body.scrollTop
    });

    // go fullscreen
    document.body.classList.add('is-fullscreen');
    document.body.classList.add('is-fixed');

    if (name === 'ism') {
      // enable zooming with scroll when fullscreen
      SIM.actions.zoomer.emit(SIM.actions.zoomer.EVENTS.SCROLL_TO_ZOOM, true);
      SIM.actions.zoomer.emit(SIM.actions.zoomer.EVENTS.RESET);
    }
  }

  unfix (name) {
    if (embeddedCheckout.isEnabled()) {
      embeddedCheckout.collapseFullScreen();
    }

    document.body.classList.remove('is-fixed');
    document.body.classList.remove('is-fullscreen');

    // restrong scroll position
    document.body.scrollTop = this.state.scrollTop;

    // Disable zooming when not full screen
    if (this.state.activeModule === 'ism') {
      SIM.actions.zoomer.emit(SIM.actions.zoomer.EVENTS.SCROLL_TO_ZOOM, false);
      SIM.actions.zoomer.emit(SIM.actions.zoomer.EVENTS.RESET);
    }

    this.setState({ scrollTop: 0, activeModule: false});
  }

  toggle (name) {
    (this.state.activeModule === name) ? this.unfix() : this.fix(name);
  }

  register (name, el) {
    this.setState({
      modules: {...this.state.modules, [name]: el}
    });
  }

  deregister (name) {
    const newModules = {...this.state.modules};
    delete newModules[name];
    this.setState({modules: newModules});
  }
}



// WEBPACK FOOTER //
// ./frontend/react/stores/fullscreen/index.js